import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PaymentCreateForm from './PaymentCreateForm';

const NewPayment = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const defaultPatientId = searchParams.get('patientId') || undefined;

  const handleSuccess = (patientId, createdPayment) => {
    if (patientId) {
      navigate(`/patients/${patientId}/payments`, {
        state: {
          message: 'Pago registrado exitosamente',
          toastKey: `payment-created-${Date.now()}`,
          payment: createdPayment || null
        }
      });
    } else {
      navigate(-1);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <PaymentCreateForm
      isModal={false}
      onSuccess={handleSuccess}
      onCancel={handleCancel}
      defaultPatientId={defaultPatientId}
    />
  );
};

export default NewPayment;
